import React, {cloneElement, useEffect} from "react";
import {Button, MenuItem} from "@material-ui/core";
import ButtonMenuBarCollapse from "./buttonMenuBarCollapse";
import {Link, useLocation, useRouteMatch} from 'react-router-dom';
import {makeStyles} from "@material-ui/core/styles";
import 'firebase/auth';
import usePersistentStore from "../../../persistentStore";
import {isVisible} from "../../../utils/display";
import SettingsMenu from "../settingsMenu";

const useStyles = makeStyles(theme => ({
    root: {
        position: "absolute",
        right: 0
    },
    buttonBar: {
        [theme.breakpoints.down("sm")]: {
            display: "none"
        },
        margin: "10px",
        paddingLeft: "16px",
        right: 0,
        position: "relative",
        width: "100%",
        background: "transparent"
    }
}));


const MenuBar = (props) => {
    const classes = useStyles();
    const [globalPersistentState] = usePersistentStore();
    let {url} = useRouteMatch();
    let location = useLocation();

    const activeRoute = (route, url) => {
        if (location.pathname === '/' && route === '/') {
            return true;
        } else return location.pathname.indexOf(route) === 0;
    };

    return (
        <div className={classes.root}>
            <ButtonMenuBarCollapse>
                {Object.keys(props.parent.routes).map((key, idx) => {
                    const route = props.parent.routes[key];

                    if (route.showInMenu) {
                        if (isVisible(
                            globalPersistentState.me,
                            globalPersistentState.state,
                            route.visibleRoles,
                            route.visibleStates,
                            typeof route.visibleTest !== 'undefined',
                            route.visibleTest)) {
                            if (route.title) {
                                let idName;
                                if (route.path) idName = route.title.replace(/\s+/g, '-').toLowerCase();

                                return <MenuItem
                                    key={idx}
                                    id={`tab-menu-${idName}`}
                                    name={`tab-menu-${idName}`}
                                    aria-label={`tab-menu-${idName}`}
                                    // disabled={isDisabled(globalPersistentState.me, route.enabledRoles)}
                                    component={Link}
                                    to={`${route.path}`}
                                >
                                    {route.title}
                                </MenuItem>
                            } else {
                                return cloneElement(
                                    route.component,
                                    {
                                        ...props,
                                        key: idx,
                                        parent: route
                                    }
                                )
                            }
                        }
                    }
                    return null;
                })}
                {globalPersistentState.me && <SettingsMenu/>}
            </ButtonMenuBarCollapse>
            <div className={classes.buttonBar} id="appbar-collapse">
                {Object.keys(props.parent.routes).map((key, idx) => {
                    const route = props.parent.routes[key];

                    if (route.showInMenu) {
                        if (isVisible(
                            globalPersistentState.me,
                            globalPersistentState.state,
                            route.visibleRoles,
                            route.visibleStates,
                            typeof route.visibleTest !== 'undefined',
                            route.visibleTest)) {
                            if (route.title) {
                                let idName;
                                if (route.path) idName = route.title.replace(/\s+/g, '-').toLowerCase();

                                return <Button
                                    key={idx}
                                    color="inherit"
                                    id={`tab-button-${idName}`}
                                    name={`tab-button-${idName}`}
                                    // disabled={isDisabled(globalPersistentState.me, route.enabledRoles)}
                                    aria-label={`tab-button-${idName}`}
                                    component={Link}
                                    to={`${route.path}`}
                                    variant={activeRoute(route.path, url) ? "outlined" : "text"}
                                >
                                    {route.title}
                                </Button>
                            } else {
                                return cloneElement(
                                    route.component,
                                    {
                                        ...props,
                                        key: idx,
                                        parent: route
                                    }
                                )
                            }
                        }
                    }
                    return null;
                })}
                {globalPersistentState.me && <SettingsMenu/>}
            </div>
        </div>
    );
};

export default MenuBar;
